import React from 'react';

function Header() {
  return (
    <div id="head_section">
      <span className="logo">
        <img src="/images/logo.png" width="629" height="113" alt="ISR Polytechnic Logo" />
      </span>
      <div id="top_contact">
        <span className="Top_contactdetails">
          Call us: <span className="Top_contact_callus">0820-2574049 / 8762070232</span><br />
          Email: <a href="mailto:isrpsksp@yahoo.com">isrpsksp@yahoo.com</a>
        </span>
      </div>
    </div>
  );
}

export default Header;
